import Matter from "matter-js";

function startAnimation() {
	var containerW = document.getElementById('matter').offsetWidth;
	var containerH = document.getElementById('matter').offsetHeight;
	var Engine = Matter.Engine,
		Render = Matter.Render,
		Events = Matter.Events,
		MouseConstraint = Matter.MouseConstraint,
		Mouse = Matter.Mouse,
		World = Matter.World,
		Bodies = Matter.Bodies;

	// create an engine
	var engine = Engine.create(),
		world = engine.world;


	// create a renderer
	var render = Render.create({
		element: document.getElementById('matter'),
		engine: engine,
		options: {
			width: containerW,
			height: containerH,
			pixelRatio: 2,
			background: 'transparent',
			wireframes: false,
		}
	});


	// create bounds// create bounds
	var ground = Bodies.rectangle(containerW / 2, containerH + 81, containerW, 160, { isStatic: true });
	var wallLeft = Bodies.rectangle(0, containerH / 2, 1, containerH, { isStatic: true });
	var wallRight = Bodies.rectangle(containerW + 1, containerH / 2, 1, containerH, { isStatic: true });
	var roof = Bodies.rectangle(containerW / 2, -81, containerW, 160, { isStatic: true });


	var radius = 20

	// create objects

	var curiosity = Bodies.rectangle((containerW * 0.20), -5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/curiosity.svg', xScale: 1, yScale: 1 }}})
	// var curiosity2 = Bodies.rectangle((containerW * 0.45), 30, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/curiosity.svg', xScale: 1, yScale: 1 }}})

	var discover = Bodies.rectangle((containerW * 0.40), -5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/discover.svg', xScale: 1, yScale: 1 }}})
	// var discover2 = Bodies.rectangle((containerW * 0.50), 5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/discover.svg', xScale: 1, yScale: 1 }}})

	var education = Bodies.rectangle((containerW * 0.47), -5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/education.svg', xScale: 1, yScale: 1 }}})
	// var education2 = Bodies.rectangle((containerW * 0.55), 5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/education.svg', xScale: 1, yScale: 1 }}})

	var play = Bodies.rectangle((containerW * 0.24), -5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/play.svg', xScale: 1, yScale: 1 }}})
	// var play2 = Bodies.rectangle((containerW * 0.60), 5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/play.svg', xScale: 1, yScale: 1 }}})

	var science = Bodies.rectangle((containerW * 0.58), -5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/science.svg', xScale: 1, yScale: 1 }}})
	// var science2 = Bodies.rectangle((containerW * 0.65), 5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/science.svg', xScale: 1, yScale: 1 }}})

	var innovate = Bodies.rectangle((containerW * 0.60), 40, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/innovate.svg', xScale: 1, yScale: 1 }}})
	// var innovate2 = Bodies.rectangle((containerW * 0.70), 5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/innovate.svg', xScale: 1, yScale: 1 }}})

	var shop = Bodies.rectangle((containerW * 0.80), 40, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/shop.svg', xScale: 1, yScale: 1 }}})
	// var shop2 = Bodies.rectangle((containerW * 0.75), 5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/shop.svg', xScale: 1, yScale: 1 }}})
	
	var technology = Bodies.rectangle((containerW * 0.45), -5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/technology.svg', xScale: 1, yScale: 1 }}})
	// var technology2 = Bodies.rectangle((containerW * 0.80), 30, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/technology.svg', xScale: 1, yScale: 1 }}})
	
	var learn = Bodies.rectangle((containerW * 0.6), -5, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/learn.svg', xScale: 1, yScale: 1 }}})
	// var learn2 = Bodies.rectangle((containerW * 0.85), 30, 178, 52, {chamfer: {radius: radius}, render: { sprite: { texture: '../dist/images/icons/learn.svg', xScale: 1, yScale: 1 }}})
	


	// Original Shape
	// var illustration = Bodies.rectangle(70, 500, 133, 40, {render: { fillStyle: arts}, chamfer: {radius: 20}})
	// add all of the bodies to the world
	World.add(engine.world, [
		ground, wallLeft, wallRight, roof,
		curiosity,
		discover,
		education,
		innovate,
		learn,
		play,
		science,
		shop,
		technology,
	]);

	// add mouse control
	var mouse = Mouse.create(render.canvas),
		mouseConstraint = MouseConstraint.create(engine, {
		mouse: mouse,
		constraint: {
			stiffness: 0.2,
			render: {
			visible: false
			}
		}
		});

	World.add(world, mouseConstraint);
	
	// keep the mouse in sync with rendering
	render.mouse = mouse;

	// Allow page scrolling in matter.js window
	mouse.element.removeEventListener("mousewheel", mouse.mousewheel);
	mouse.element.removeEventListener("DOMMouseScroll", mouse.mousewheel);

	// Detect clicks vs. drags
	let click = false;

	document.addEventListener('mousedown', () => click = true);
	document.addEventListener('mousemove', () => click = false);
	document.addEventListener('mouseup', () => console.log(click ? 'click' : 'drag'));

	// Create a On-Mouseup Event-Handler
	Events.on(mouseConstraint, 'mouseup', function(event) {
	var mouseConstraint = event.source;
	var bodies = engine.world.bodies;
	if (!mouseConstraint.bodyB) {
		for (let i = 0; i < bodies.length; i++) { 
		var body = bodies[i];
		// Check if clicked or dragged
		if (click === true) {
		if (Matter.Bounds.contains(body.bounds, mouseConstraint.mouse.position)) {
			var bodyUrl = body.url;
			console.log("Body.Url >> " + bodyUrl);
			// Hyperlinking feature
			if (bodyUrl != undefined) {
				//window.location.href = bodyUrl;
				window.open(bodyUrl, '_blank');
				console.log("Hyperlink was opened");
			}
			break;
			}
		}
		}
	}
	});

	// run the engine
	Engine.run(engine);

	// run the renderer
	Render.run(render);

}



// Use Intersection Observer
document.addEventListener('DOMContentLoaded', function () {
    var testElement = document.querySelector('#matter');

    var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                // If #test is in view, start the animation
                setTimeout(function () {
                    startAnimation();
                }, 400);
                // Stop observing once animation is triggered (optional)
                observer.unobserve(testElement);
            }
        });
    }, { threshold: 0.5 }); // You can adjust the threshold as needed

    // Start observing #test
    observer.observe(testElement);
});